import { Button, Card, CardActions, CardContent, List, Typography } from "@mui/material";
import { Feature } from "../../../Objects/Model/Feature";
import { WhatsNewItem } from "./WhatsNewItem";
import { Grow } from "../Common/Grow";
import { ArrowheadTheme } from "../../Theme/ArrowheadTheme";
import { SRTabs } from "../Layout/AHDrawer";
import { useCallback } from "react";
import { Version } from "../../../Objects/Helpers/Statics/Version";

interface WhatsNewProps
{
	gamertag?: string;
	onDismiss(): void;
	switchTab: (url?: string, tab?: SRTabs) => void;
}

export function WhatsNew(props: WhatsNewProps)
{
	const { gamertag, onDismiss, switchTab } = props;

	const features: Map<string, Feature[]> = new Map();

	const onJump = useCallback((to: string) =>
	{
		if (to.startsWith("http")) { window.open(to); }
		else { switchTab(to); }
	}, [switchTab]);

	features.set("48", [
		new Feature("This What's New section!", "Not a fan? You can dismiss it."),
		new Feature("Three new extraction medals", "Clear Reception, Call Blocked, and Hang Up"),
		new Feature("Patreon", "Consider subscribing to help keep SpartanRecord running!"),
	]);

	features.set("49", [
		new Feature("Infection post-match summary", "See the amount of times you were alpha zombie"),
		new Feature("Game mode breakdowns", "See the game mode breakdowns directly on the Service Record page"),
		new Feature("Infection mode breakdown", "See your career infection breakdowns"),
		new Feature("Extraction mode breakdown", "See your career extraction breakdowns"),
		new Feature("Bug fixes", "Career Rank and CSR bug fixes"),
		new Feature("Patreon", "Consider subscribing to help keep SpartanRecord running!"),
	]);

	features.set("4.10", [
		new Feature("Active Playlists redesign", "See the map and mode odds for a specific playlist"),
		new Feature("Patreon", "Consider subscribing to help keep SpartanRecord running!"),
	]);

	features.set("4.11", [
		new Feature("Firefight", "Review Firefight match summaries"),
		new Feature("Match Summary CSR Leaders", "See the lobby's CSR leaders from top to bottom in the match summary"),
		new Feature("Patreon", "Consider subscribing to help keep SpartanRecord running!"),
	]);

	features.set("4.12", [
		new Feature("Extended Firefight Stats", "Review Firefight match summaries in extra detail + view your Firefight stats in your Service Record"),
		new Feature("Patreon", "Consider subscribing to help keep SpartanRecord running!", "subscribe"),
	]);

	features.set("4.13", [
		new Feature("Ranked Arena Leaderboard", "See the top 100 players in Ranked Arena with our new leaderboards page", "leaderboard/edfef3ac-9cbe-4fa2-b949-8f29deafd483"),
		new Feature("Extended Firefight Stats", "Review Firefight match summaries in extra detail + view your Firefight stats in your Service Record"),
		new Feature("Patreon", "Consider subscribing to help keep SpartanRecord running!", "subscribe"),
	]);

	features.set("4.14", [
		new Feature("Your Great Journey to Hero", "Set a goal date and see how many games you need play per day to achieve the Hero rank"),
		new Feature("Ranked Arena Leaderboard", "See the top 100 players in Ranked Arena with our new leaderboards page", "leaderboard/edfef3ac-9cbe-4fa2-b949-8f29deafd483"),
		new Feature("Patreon", "Subscribe to go ad-free for your gamertag", "subscribe"),
	]);

	features.set("4.15", [
		new Feature("Your Great Journey to Hero (Alternate Mode)", "Set your games / day and see what date you will hit Hero"),
		new Feature("Multi-Team Support", "View multi-team match summaries"),
		new Feature("Patreon", "Subscribe to go ad-free for your gamertag", "subscribe"),
	]);

	features.set("4.16", [
		new Feature("Check our your 2024 Year in Review", "See your Halo Infinite statistics for 2024"),
		new Feature("Patreon", "Subscribe to go ad-free for your gamertag", "subscribe"),
	]);

	features.set("4.17", [
		new Feature("Export your Service Record", "Now you can export your Service Record to CSV"),
		new Feature("Patreon", "Subscribe to go ad-free for your gamertag", "subscribe"),
	]);

	features.set("4.18", [
		new Feature("New iOS App", "Track your stats in the brand new Spartan Record app!", "https://apps.apple.com/us/app/spartan-record/id6470414461"),
		new Feature("Patreon", "Subscribe to go ad-free for your gamertag", "subscribe"),
	]);

	features.set("4.19", [
		new Feature("iOS App", "Track your stats in the Spartan Record app!", "https://apps.apple.com/us/app/spartan-record/id6470414461"),
		new Feature("Patreon", "Subscribe to go ad-free for your gamertag", "subscribe"),
	]);

	features.set("4.20", [
		new Feature("Goodbye Ads", "Honestly I was only making like $3 a month on these, so it's time to remove them. Consider donating to keep SpartanRecord.com up and running!", "subscribe"),
		new Feature("iOS App", "Track your stats in the Spartan Record app!", "https://apps.apple.com/us/app/spartan-record/id6470414461"),
	]);

	return (
		<Card sx={{ background: ArrowheadTheme.card + "DD" }}>
			<CardContent>
				<Typography gutterBottom variant="h5" component="div" sx={{ fontWeight: 700 }}>What's new?</Typography>
				<List>
					{features.get(Version.majorVersion || "47")?.map(feature => <WhatsNewItem feature={feature} onJump={onJump} />)}
				</List>
			</CardContent>
			<CardActions>
				<Grow />
				<Button variant="outlined" onClick={() => switchTab(`subscribe/${gamertag}`, SRTabs.Subscribe)}>Donate</Button>
				<Button variant="contained" onClick={onDismiss}>Dismiss</Button>
			</CardActions>
		</Card>
	);
}